// extracted by mini-css-extract-plugin
export default {"container":"MultiTabHeader_container__y6mYV","tabs":"MultiTabHeader_tabs__-Tbua"};